import { defineStore } from "pinia";

interface PagePositionData {
  path: string;
  top: number;
}

interface LayoutState {
  globalLoading: boolean;
  pageLoading: boolean;
  pagePositions: PagePositionData[];
  contentLoaded: boolean;
  backNavigation: boolean;
}

export const useLayoutStore = defineStore("layout", {
  state: (): LayoutState => ({
    globalLoading: false,
    pageLoading: false,
    pagePositions: [],
    contentLoaded: false,
    backNavigation: false,
  }),

  getters: {
    getGlobalLoading: (state: LayoutState) => state.globalLoading,
    getPageLoading: (state: LayoutState) => state.pageLoading,
    getPagePosition: (state: LayoutState) => {
      const positions: PagePositionData[] = [...state.pagePositions];
      return positions.shift();
    },
    isBackNavigation: (state: LayoutState) => state.backNavigation,
    getContentLoaded: (state: LayoutState) => state.contentLoaded,
  },

  actions: {
    setGlobalLoading(value: boolean) {
      this.globalLoading = value;
    },
    setPageLoading(value: boolean) {
      this.pageLoading = value;
    },
    setPagePosition(data: PagePositionData) {
      const positions = this.pagePositions;
      positions.push(data);

      this.pagePositions = positions.slice(-2);
    },
    setBackNavigation(isBack: boolean) {
      this.backNavigation = isBack;
    },
    setContentLoaded(value: boolean) {
      this.contentLoaded = value;
    },
  },
});
